import Vue from 'vue';
import AutarkyRetainRightsPopup from './popup.vue';

interface RightParams {
  sellPrice?: string | number;
  contractInfo?: {
    name?: string;
    scene?: string;
  };
}

interface PopupResult {
  success: boolean;
  action: string;
}

export enum ActionTypeEnum {
  CLICK_RREVIEW_CONTRACT = '预览协议',
  CLICK_DETAIL = '查看详情',
  AGREE = '同意协议并提交',
  REJECT = '放弃优先审核',
}

class AutarkyRetainRightsPopupService {
  private instance: Vue | null = null;

  private resolvePromise: ((value: PopupResult) => void) | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rejectPromise: ((reason?: any) => void) | null = null;

  /**
   * 显示弹窗
   * @param rightParams 权益参数
   * @returns Promise<PopupResult> 返回用户选择结果
   */
  public show(
    { rightParams, goDetail, contractPreview }:
    { rightParams: RightParams,
      goDetail: () => void,
      contractPreview: () => void
  },
  ): Promise<PopupResult> {
    return new Promise((resolve, reject) => {
      this.resolvePromise = resolve;
      this.rejectPromise = reject;

      // 创建弹窗实例
      if (!this.instance) {
        try {
          this.instance = new Vue({
            render: (h) => h(AutarkyRetainRightsPopup, {
              props: {
                rightParams,
                modelValue: true,
                goDetail,
                contractPreview,
              },
              on: {
                'update:modelValue': (value: boolean) => {
                  if (!value) {
                    this.hide();
                  }
                },
                choose: (success: boolean, action: string) => {
                  // this.hide();
                  resolve({ success, action });
                },
              },
            }),
          });

          // 挂载到DOM
          const mountedDom = document.createElement('div');
          document.body.appendChild(mountedDom);
          this.instance.$mount(mountedDom);
        } catch (error) {
          reject(new Error('弹窗创建失败'));
        }
      } else {
        // 更新参数并显示
        if (this.instance.$children && this.instance.$children.length) {
          this.instance.$children[0].$props.modelValue = true;
          this.instance.$children[0].$props.rightParams = rightParams;
        }
      }
    });
  }

  /**
   * 隐藏弹窗
   */
  public hide(): void {
    if (this.instance) {
      if (this.instance.$children && this.instance.$children.length) {
        this.instance.$children[0].$props.modelValue = false;
      }

      // 延迟销毁实例，避免闪烁
      // setTimeout(() => {
      //   if (this.instance && this.instance.$el && this.instance.$el.parentNode) {
      //     this.instance.$el.parentNode.removeChild(this.instance.$el);
      //   }
      //   this.instance = null;
      // }, 300);
    }

    // 如果有未处理的Promise，reject它
    if (this.rejectPromise) {
      this.rejectPromise(new Error('弹窗被关闭'));
      this.rejectPromise = null;
    }
  }

  /**
   * 销毁弹窗实例
   */
  public destroy(): void {
    if (this.instance) {
      this.hide();
      this.instance = null;
    }
  }
}

// 创建单例
const autarkyRetainRightsPopupService = new AutarkyRetainRightsPopupService();

// 导出服务实例和便捷方法
export default autarkyRetainRightsPopupService;

// 便捷的show方法
export const showAutarkyRetainRightsPopup = (
  { rightParams, goDetail, contractPreview }:
  { rightParams: RightParams,
    goDetail: () => void,
    contractPreview: () => void
  },
): Promise<PopupResult> => autarkyRetainRightsPopupService.show({
  rightParams, goDetail, contractPreview,
});

// 便捷的hide方法
export const hideAutarkyRetainRightsPopup = (): void => {
  autarkyRetainRightsPopupService.hide();
};

// 便捷的destroy方法
export const destroyAutarkyRetainRightsPopup = (): void => {
  autarkyRetainRightsPopupService.destroy();
};
